module.exports = __webpack_public_path__ + "media/images/product/a2-b20ff73683b713981c96e1a5d35f322f.png";